import { render, staticRenderFns } from "./Page-edit.vue?vue&type=template&id=a7c3171a"
import script from "./Page-edit.vue?vue&type=script&lang=js"
export * from "./Page-edit.vue?vue&type=script&lang=js"
import style0 from "./Page-edit.vue?vue&type=style&index=0&id=a7c3171a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports